import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    flexShrink: 0,
    padding: `0 ${spacing(2)}px`,
  },
  button: {
    color: colors.textMainPrimary,
    marginLeft: spacing(1),
    marginRight: spacing(1),
  },
});

export default styles;
